import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    amount: number;
}

function CardAmount({ amount }:Props) {
    const { t } = useTranslation('gift');
    return (
        <Column spacing={22} fullWidth>
            <Text size='2xl' fontWeight='bold' color={colors.gray7}>
                {t('giftOrder.purchaseAmount')}
            </Text>
            <Chip.Container className={styles.amount}>
                <Chip isSelected>{amount / 10000}{t('giftOrder.amountUnit')}</Chip>
            </Chip.Container>
        </Column>
    );
}

export default CardAmount;
